
import { Helmet } from 'react-helmet';
import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import Footer from '../../components/home-main/Footer';
import Navbar from '../../components/home-main/Navbar';
import Header from '../../components/join-us/Header';
import JoinForm from '../../components/join-us/JoinForm';

export default function JoinUsPage() {
  return (
    <>
    <Helmet>
        <title>GCAD - Join Us</title>
        <link rel="icon" href="/light/assets/imgs/fox.webp" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />

        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <main>
        <Cursor />  
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <JoinForm />
            </main>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
}
